<template>
  <footer>
    <img src="../assets/images/footer/logo.png" class="logo" alt />
    <img src="../assets/images/footer/yostar_logo.png" class="yostar-logo" alt="">
    <div class="item-box">
      <router-link target="_blank" class="item-box-a" to="/privacy_policy"
        >Privacy Policy</router-link
      >
      <router-link target="_blank" class="item-box-a" to="/terms_of_service"
        >Terms of Service</router-link
      >
      <a href="mailto:al.cs@yo-star.com" class="item-box-a">CONTACT US</a>
      <br />
      <p class="information">
        ©2018 Shanghai Manjuu Technology Co.,Ltd & Xiamen YongShi Technology
        Co.,Ltd.
      </p>
      <p class="information">
        ©2018 Shanghai Yostar Co., Ltd. All rights reserved
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",

  components: {},
  data: () => ({}),
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  padding: pxTorem(30px) pxTorem(20px);
  box-sizing: border-box;
  border-top: 1px solid #333333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .logo {
    display: block;
    // width: pxTorem(181px);
    height: pxTorem(55px);
  }
  .yostar-logo {
    height: pxTorem(45px);
    margin-right: auto;
    margin-left: pxTorem(20px);
  }
  .item-box {
    .item-box-a {
      font-size: pxTorem(18px);
      color: #878787;
      padding: 0 pxTorem(6px);
      border-right: 1px solid #878787;
      &:hover {
        color: #d3a045;
      }
    }
    .item-box-a:last-of-type {
      border-right: none;
    }
    .information {
      font-size: pxTorem(18px);
      color: #878787;
    }
  }
}
</style>
